import { useEffect, useState } from "react";

const TARGET_KEY = "ie_offer_target";

function getTarget() {
  let stored = localStorage.getItem(TARGET_KEY);
  if (stored) {
    const t = parseInt(stored, 10);
    if (t > Date.now()) return t;
  }
  // 36 hour window from first visit
  const t = Date.now() + 36 * 60 * 60 * 1000;
  localStorage.setItem(TARGET_KEY, String(t));
  return t;
}

export default function CountdownTimer({ label = "Atelier Edit ends in" }) {
  const [target] = useState(getTarget);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, target - now);
  const h = String(Math.floor(diff / 3_600_000)).padStart(2, "0");
  const m = String(Math.floor((diff / 60_000) % 60)).padStart(2, "0");
  const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

  return (
    <div className="inline-flex items-center gap-4" data-testid="offer-countdown">
      <span className="ie-overline text-text-secondary">{label}</span>
      <div className="flex items-center gap-2 font-serif text-2xl md:text-3xl">
        <span className="tabular-nums">{h}</span>
        <span className="opacity-30">:</span>
        <span className="tabular-nums">{m}</span>
        <span className="opacity-30">:</span>
        <span className="tabular-nums">{s}</span>
      </div>
    </div>
  );
}
